import { Link } from 'react-router-dom';
import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="bg-primary-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-background-50/20 rounded-xl">
                <i className={`${stat.icon} text-background-50 text-xl`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-1">{stat.value}</div>
              <div className="text-sm text-background-50/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}